import styled, { keyframes, css } from 'styled-components';
import { color, transition, makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

interface SuccessTextProps {
  complete?: boolean;
}

const popIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const animateText = (props: SuccessTextProps) =>
  props.complete &&
  css`
    animation: ${popIn} 500ms 1000ms ${transition.CURVE} forwards;
  `;

export const SuccessText = styled.span<SuccessTextProps>`
  display: inline-block;
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  opacity: 0;
  color: ${color.GREEN};
  ${animateText};
`;

export const useStyles = (props: { flow: string; fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      processingText: {
        lineHeight: 1,
        fontSize: 64,
        fontWeight: 600,
        textAlign: 'center',
        margin: '0 0 140px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal',
        [theme.breakpoints.down('lg')]: {
          lineHeight: props.flow === 'fair' ? 1 : 1.2
        },
        [theme.breakpoints.only('lg')]: {
          margin: '0 0 42px'
        }
      },
      processingContainer: {
        maxWidth: '950px',
        height: '610px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          height: '635px'
        }
      }
    })
  );
